var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-button--options-pad"},_vm._l((_vm.options),function(option){return _c('button',{key:option.value,staticClass:"c-button c-button--square c-button--primary",on:{"click":function($event){$event.preventDefault();return _vm.valuePressed(option.value)}}},[_vm._v(" "+_vm._s(option.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }